import { useContext } from 'react';
import UserContext, { UserContextProperties } from '../context/UserContext';

export default (): UserContextProperties => useContext(UserContext);
